module.exports = __webpack_public_path__ + "img/Group 204.473796f9.png";